import styled from 'styled-components';

type PropsSiteAgentStyled = {};

export const SiteAgentStyled = styled.div<PropsSiteAgentStyled>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  .ant-table {
    .ant-table-content {
      table {
        padding: 0px 2px;
      }
      .ant-table-tbody {
        tr {
          &:first-child {
            td {
              &:not(:first-child) {
                position: relative;
                &::before {
                  position: absolute;
                  content: '';
                  display: inline-block;
                  border-left: 1px solid rgba(0, 0, 0, 0.07);
                  height: 24px;
                  width: 1px;
                  left: 0px;
                }
              }
            }
          }
        }
      }
      .ant-table-thead {
        > tr {
          > th {
            padding-top: 12px;
            padding-left: 16px;
            padding-bottom: 8px;
          }
        }
      }
      .ant-table-tbody {
        tr {
          td {
            padding: 16px 24px 24px 24px;
          }
        }
        .ant-table-row {
          td {
            padding-top: 16px;
            padding-left: 16px;
            padding-bottom: 18px;
          }
        }
        tr:first-child {
          td:first-child {
            border-top-left-radius: 8px;
            border-bottom-left-radius: 8px;
          }
          td:last-child {
            border-top-right-radius: 8px;
            border-bottom-right-radius: 8px;
          }
        }
        tr:last-child td:first-child {
          border-bottom-left-radius: 8px;
        }
        tr:last-child td:last-child {
          border-bottom-right-radius: 8px;
        }
      }
    }
  }

  & .ant-table-container {
    width: 100vw;
    padding: 0 32px;
  }
  & .ant-table-wrapper {
    & .ant-table .ant-table-content .ant-table-thead {
      tr {
        th {
          &:first-child {
            padding-left: 24px;
          }
          &:last-child {
            padding-right: 24px;
          }
        }
      }
    }
    & .ant-table .ant-table-content .ant-table-tbody {
      tr {
        td {
          &:first-child {
            padding-left: 24px;
          }
          &:last-child {
            padding-right: 24px;
          }
        }
      }
    }
  }
  .separate {
    height: 8px;
  }
`;

interface PropStatusJobCP {
  color: string;
}

export const StatusJobStyled = styled.div<PropStatusJobCP>`
  width: 56px;
  height: 20px;
  border-radius: 4px;
  background-color: ${(props) => props.color};
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 18px;
`;
export const StatusRkyStyled = styled.div<{ bgColor?: string }>`
  min-height: 24px;
  .box-status {
    width: 96px;
    height: 20px;
    border-radius: 4px;
    background-color: #e65050;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 18px;
    &.approved {
      background-color: #69b362;
      width: 56px;
    }
    .line {
      border-left: #ffffff solid 1px;
      height: 12px;
      margin: 0 8px;
    }
  }
`;
